<template>
  <div>
    <esg-table-without-meta :items="items"
                            :fields="fields"
                            :striped="false"
                            max-height="450px"
                            size="xs">
    </esg-table-without-meta>
  </div>
</template>
<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: { EsgTableWithoutMeta },
  props: {
    type: {
      type: String,
      default: 'O'
    },
    corporation: {
      type: Object,
      default() {
        return {}
      }
    },
    businessLocation: {
      type: Object,
      default() {
        return {}
      }
    },
    firstYear: {
      type: Number,
      default: 2018
    },
    lastYear: {
      type: Number,
      default: 2050
    }
  },
  watch: {
    type: {
      handler() {
        this.fetchData();
      }
    },
    lastYear: {
      handler() {
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  // 감축 수단별 비용
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        // Set field meta data
        this.setFields();

        let args = {
          years: Array.from({ length: this.lastYear - this.firstYear + 1 }, (_, index) => this.firstYear + index),
          groupKeys: ['cost_type', 'abatement_method_value', 'abatement_method_name', 'year']
        };
        this.corporation.name && (args.corporations = [this.corporation.code])
        this.businessLocation.name && (args.businessLocations = [this.businessLocation.business_location_code])

        let data = new FormData()
        data.append('path', 'esg/cost/main');
        data.append('json', JSON.stringify([args]));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          this.series = [];
          return;
        }


        // Parse JSON data
        let tableData = JSON.parse(response.data.data)[0].data
            .filter(row => row.cost_type === this.type);

        // Manipulate table data according to the given type and set the items
        this.setItems(tableData);

        // Calculate total and push it to the items
        this.total = tableData.reduce((a, b) => a + b.cost_total, 0)
      } catch (error) {
        this.loading = false;
        await this.showError(error)
      } finally {
        this.loading = false;
      }
    },
    setItems(data) {
      // Pivot the data into wide format
      this.items = data.reduce((accumulator, item) => {
        // Check if the abatement method is already in the accumulator
        let methodEntry = accumulator.find(entry => entry.abatement_method_name === item.abatement_method_name);

        // If the type doesn't exist in the accumulator, create it
        if (!methodEntry) {
          methodEntry = { abatement_method_name: item.abatement_method_name, total: 0 };
          accumulator.push(methodEntry);
        }

        // Add the year-value pair to the typeEntry
        methodEntry[item.year.toString()] = item.cost_total;
        methodEntry.total += item.cost_total

        return accumulator;
      }, []);
    },
    setFields() {
      // Years starting from 2018 to 2050
      const years = Array.from({ length: this.lastYear - this.firstYear + 1 }, (_, index) => this.firstYear + index);

      let fields = [{ name: 'abatement_method_name', label: '감축수단', list: true }]

      years.forEach(year => fields.push({
        name: year.toString(),
        label: year.toString(),
        formatter: val => val ? this.formatNumber(val / 10e8, 0, 2) : '-',
        list: true
      }));

      fields.push({
        name: 'total',
        label: '합계',
        list: true,
        formatter: val => this.formatNumber(val / 10e8, 0, 2),
      });

      this.fields = fields;
    }
  },
  data() {
    return {
      loading: false,
      total: 0,
      items: [],
      fields: []
    }
  },
}
</script>